/* globals ga */
import initFilter from '@PROJECT_ROOT/assets/mobile/js/privateAccommodation/searchFilterForm';
import initializeSimpleGalleries from '@PROJECT_ROOT/assets/mobile/js/privateAccommodation/searchResultsGallery';
import loadGoogleMaps from '@PROJECT_ROOT/assets/mobile/js/infrastructure/loadGoogleMaps';
import makeGetPlaceInfo from '@PROJECT_ROOT/assets/desktop/js/search/mapsearch/GooglePlaceInfo';
import makeLoadSearchResultsMap from '@PROJECT_ROOT/assets/mobile/js/privateAccommodation/searchResultsMap';
import openModal from '@PROJECT_ROOT/assets/shared/js/modalBox';
import toggleExteriorSizeVisibility from '@PROJECT_ROOT/assets/mobile/js/privateAccommodation/toggleExteriorSizeVisibility';
import { heightChanged, legacyHeightChanged } from '@PROJECT_ROOT/assets/shared/js/frameToPartnerMessageTypes';

function sendGoogleAnalyticsEventIfFirstPage() {
    const $searchResultsDivSelector = $('#facilities');
    const total = $searchResultsDivSelector.data('total-facilities');
    const currentPage = $searchResultsDivSelector.data('current-page');
    if (typeof (ga) !== 'undefined' && parseInt(currentPage, 10) === 1) {
        ga('send', 'event', 'Rezultati pretrage', 'Rezultati', total.toString());
    }
}

function initDoubleFacilityScroll() {
    $('.sharedFacility').on('click', function scrollToDoubleFacility(e) {
        e.preventDefault();
        const scrollToFacilityId = parseInt(this.getAttribute('data-facility-id'), 10);
        const scrollToElement = document.querySelector(`li[data-facility-id="${scrollToFacilityId}"]`);
        scrollToElement.classList.remove('shared');
        scrollFacilityToMiddle(scrollToElement);
    });
}

function scrollFacilityToMiddle(scrollToElement) {
    const elementPositon = $(scrollToElement).offset().top;
    const windowHeight = window.screen.height;
    const halfOfElement = scrollToElement.offsetHeight / 2;
    const scrollTo = elementPositon - windowHeight / 2 + halfOfElement;

    $('html, body').animate({ scrollTop: scrollTo }, 300, 'swing', () => {
        scrollToElement.classList.add('shared');
    });
}

function setAllLocationTitlesToGoogleName(locationId) {
    loadGoogleMaps().then((google) => {
        const getPlaceInfo = makeGetPlaceInfo(
            new google.maps.places.PlacesService(document.createElement('div')),
            google.maps.places.PlacesServiceStatus,
        );
        const googlePlaceFoundCallback = (name) => {
            document.getElementById('locationNameFilter').innerHTML = name;
            document.getElementById('googleLocationPlaceholder').innerHTML = name;
        };

        getPlaceInfo(locationId, googlePlaceFoundCallback, () => {});
    });
}

const searchResults = {
    init(state) {
        const $pageLoader = $('#pageLoader');
        const googleLocation = document.getElementById('googleLocationPlaceholder');
        if (googleLocation !== null) {
            setAllLocationTitlesToGoogleName(googleLocation.getAttribute('data-locationid'));
        }
        initDoubleFacilityScroll();
        $('.js-showMoreUnits').on('click', function showMoreUnits() {
            $(this).hide();
            $(this).parent().addClass('showAll');
            window.parent.window.postMessage(heightChanged(), '*');
            window.parent.window.postMessage(legacyHeightChanged(document), '*');
        });

        $(document).on('click', '#sortSearchlist li a', () => {
            $pageLoader.show();
        });

        $(document).on('click', 'a.filterOffIcon', () => {
            $pageLoader.show();
        });

        $(document).on('click', '#searchFilter, .filterFormTrigger', (event) => {
            ga('send', 'event', 'Filteri', 'otvori');
            event.preventDefault();
            $pageLoader.show();

            $.get($('#searchFilter').data('ajax-url')).then((response) => {
                $pageLoader.hide();
                openModal(response.content, { overlayCss: ['filtersModal'] });
                initFilter(response.state);
            });

            window.location.hash = '#filter';
        });

        $(document).on('click', '#sortSearchButton', () => {
            $('#sortSearchlist').toggle();
        });

        $(document).on('click', '.searchFormTrigger, .destinationSearchTrigger, .pickDatesTrigger', () => {
            toggleSearchForm();
        });

        initializeSimpleGalleries();
        sendGoogleAnalyticsEventIfFirstPage();
        toggleExteriorSizeVisibility();

        function toggleSearchForm() {
            $('#searchBtn').trigger('click');
        }

        $('.sortBySelect').change((e) => {
            e.preventDefault();
            $('#sortForm').submit();
        });

        const sortSearchlist = document.getElementById('sortSearchlist');
        // Sort izbornik ne postoji na shortlist stranici
        if (sortSearchlist) {
            const sortSearchButton = document.getElementById('sortSearchButton');

            document.addEventListener('click', (event) => {
                if (
                    sortSearchlist.style.display === 'block'
                    && event.target !== sortSearchlist
                    && !sortSearchButton.contains(event.target)
                ) {
                    sortSearchlist.style.display = 'none';
                }
            });
        }

        // Uklanjanje filter parametara
        $('.filterOffIcon').click(function removeFilter() {
            $(this).closest('.filterOff').hide();
        });

        const loadSearchResultsMap = makeLoadSearchResultsMap(state);
        document.querySelector('#searchByMap').addEventListener('click', () => {
            const mapContainer = document.getElementById('searchResultsGoogleMap');
            loadGoogleMaps().then((google) => {
                loadSearchResultsMap(google, mapContainer);
            });
        });
    },
};

export default searchResults;
